import { Box } from "@/components/atoms";
import { User } from "@/types/user";
import { TextField } from "@mui/material";

export const EditableField = ({
  label,
  value,
  onChange,
  type = "text",
  ...rest
}: {
  label: string;
  value: User["email"] | User["first_name"] | User["last_name"];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  [x: string]: any;
}) => (
  <Box componentName="editable-field" sx={{ marginBottom: 2 }}>
    <TextField
      label={label}
      variant="outlined"
      value={value}
      onChange={onChange}
      type={type}
      fullWidth
      {...rest}
    />
  </Box>
);
